'use client';

import React, { useEffect } from 'react';
import { useRouter } from 'next/navigation';
import { CountryService } from '@/lib/country-service';
import CountrySelector from './components/CountrySelector';

export default function HomePage() {
  const router = useRouter();

  useEffect(() => {
    // Check if user has already selected a country
    const selectedCountry = CountryService.getSelectedCountry();
    if (selectedCountry) {
      router.push(`/${selectedCountry.code.toLowerCase()}/home`);
    }
  }, [router]);

  return <CountrySelector />;
}
